import { NgModule } from '@angular/core';

import {
  ExtraOptions,
  RouterModule,
  Routes,
  RouteReuseStrategy
} from '@angular/router';

import { AdminConfigGuard } from './guards/admin-config.guard';
import { ConfigRoleGuard } from './guards/config-role.guard';
import { ConfigLacksComponent } from './views/config-lacks/config-lacks.component';
import { ShellComponent } from './shell/shell.component';
//import { HomeComponent } from './pages/home/home.component';
import { TableReadComponent } from './views/table/read/read.component';
//import { AboutComponent } from './pages/about/about.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterValidationComponent } from './pages/validate/register-validation.component';
import { RecoveryComponent } from './pages/recovery/recovery.component';
import { NeedAuthGuard } from '@app/core/auth';
import { RouteReusableStrategy } from '@app/core';
import { StaticsComponent } from './views/statics/statics.component';
import { CalculosComponent } from './views/calculos/calculos.component';
import { HomeComponent } from './views/home/home.component';
import { BalanceComponent } from './views/balance/balance.component';
import { PestModelsComponent } from './views/pest-models/pest-models.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'validate/:token', component: RegisterValidationComponent },
  { path: 'recovery/:token', component: RecoveryComponent },
  { path: 'dashboard/recovery/:token', component: RecoveryComponent },
  { path: 'index.php/recovery/:token', component: RecoveryComponent },
  { path: 'index.php/validate/:token', component: RegisterValidationComponent },
  {
    path: 'config-lacks',
    component: ConfigLacksComponent,
    canActivate: [NeedAuthGuard]
  },
  {
    path: 'shell',
    component: ShellComponent,
    canActivate: [NeedAuthGuard],
    canActivateChild: [AdminConfigGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, data: { reuse: true } },
      { path: 'statics', component: StaticsComponent, data: { reuse: true } },
      { path: 'calculos', component: CalculosComponent, data: { reuse: true } },
      { path: 'balance', component: BalanceComponent, data: { reuse: true } },
      {
        path: 'farms/:idFinca/pest-models',
        component: PestModelsComponent
      },
      {
        path: 'pest-models',
        component: PestModelsComponent
      },
      //{ path: 'home', component: HomeComponent, data: { reuse: true } },
      //{ path: 'about', component: AboutComponent },
      {
        path: 'table/:name',
        canActivate: [NeedAuthGuard, ConfigRoleGuard],
        canActivateChild: [AdminConfigGuard],
        children: [{ path: '', component: TableReadComponent }]
      }
    ]
  },
  // Otherwise routes
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
];

const config: ExtraOptions = {};

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, config)],
  providers: [{ provide: RouteReuseStrategy, useClass: RouteReusableStrategy }]
})
class AppRoutingModule {}

export { AppRoutingModule };
